type BatchIO = {
  sendText: (text: string) => void;
  sendImage: (file: File) => Promise<void> | void;
  uploadPdf: (file: File) => Promise<void>;
};

export async function buildBatchFrames(files: File[], io: BatchIO): Promise<void> {
  io.sendText(`[batch_inizio n=${files.length}]`);
  for (const f of files) {
    // batch riceve solo immagini (PDF instradati singolarmente in ChatInput);
    // ramo difensivo, lasciato per robustezza se un chiamante futuro passa un PDF.
    if (f.type === "application/pdf") {
      await io.uploadPdf(f);
      io.sendText("[file_uploaded]");
    } else {
      await io.sendImage(f);
    }
  }
  io.sendText("[batch_completo]");
}
